import React, { ReactNode } from 'react';

import styledC from 'styled-components';

import Checkbox, { CheckboxState } from '@adsk/alloy-react-checkbox';
import theme from '@adsk/alloy-react-theme';

const StyledLabel = styledC.label`
  ${theme.typography.labelSmall}
  display: flex;
  margin-right: 8px;
  color: ${theme.tokens.colors.text.primary.value};
`;

const FooterOption = ({
  label,
  defaultChecked,
  onChange,
}: {
  label: ReactNode;
  defaultChecked?: boolean;
  onChange?: (
    state: CheckboxState,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
}) => {
  return (
    <StyledLabel>
      <Checkbox
        onChange={onChange}
        defaultChecked={defaultChecked}
        style={{ marginRight: 8 }}
      />
      {label}
    </StyledLabel>
  );
};

export default FooterOption;
